import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'currentDateWithinDateRange',
    standalone: true
})
export class CurrentDateWithinDateRangePipe implements PipeTransform {
  transform(
    startDateStr: string, endDateStr: string
  ): boolean {
    // Get the current date and strip the time component
    const now = new Date();
    now.setHours(0, 0, 0, 0);

    // Parse the start and end dates and strip their time components
    const startDate = new Date(startDateStr);
    startDate.setHours(0, 0, 0, 0);

    const endDate = new Date(endDateStr);
    endDate.setHours(0, 0, 0, 0);

    // Compare the current date with the start and end dates
    return now >= startDate && now <= endDate;
  }
}
